(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-tofu-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lp-faq]').forEach(function (section) {
    var buttons = section.querySelectorAll('.lp-faq__question');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var isOpen = this.getAttribute('aria-expanded') === 'true';

        buttons.forEach(function (btn) {
          btn.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
